<template>
  <div>
    <div>
      <el-dialog
        :title="mainTitle"
        :visible.sync="editVisible"
        width="600px"
        @close="closeEdit"
        @open="dlgOpen"
        @closed="dlgClosed"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <!-- :rules="rules" -->
        <el-form
          ref="form"
          :model="form"
          label-width="100px"
          :style="dlgBody"
          :rules="rules"
          v-loading="loading"
        >
          <el-form-item label="头像" prop>
            <el-upload
              class="avatar-uploader"
              :action="doUpload"
              :http-request="customUpload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-if="showPlus" class="el-icon-plus avatar-uploader-icon"></i>
              <el-progress
                type="circle"
                :percentage="percent"
                v-if="imgFlag == true"
                style="position: absolute;top:10%;left:2%;"
              ></el-progress>
            </el-upload>
          </el-form-item>
          <el-form-item label="用户名" prop="userName">
            <el-input
              type="userName"
              v-model.trim="form.userName"
              autocomplete="off"
              clearable
              style="width:90%"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" v-if="isShowPwd==true">
            <el-input
              v-model.trim="form.password"
              placeholder="请输入密码"
              clearable
              style="width:90%"
              :show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model.trim="form.email" placeholder="请输入邮箱" clearable style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="realName">
            <el-input v-model.trim="form.realName" placeholder="请输入姓名" clearable style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model.trim="form.sex" placeholder="请选择性别" style="width:90%">
              <el-option
                v-for="item in sexType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input v-model.trim="form.idCard" placeholder="请输入身份证号" clearable style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input v-model.trim="form.age" placeholder="请输入年龄" clearable style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model.trim="form.mobile" placeholder="请输入手机号" clearable style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="入职时间" prop="entryAt">
            <el-date-picker
              v-model.trim="form.entryAt"
              type="date"
              placeholder="选择入职时间"
              style="width:90%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="在职状态 " prop="workStatus">
            <el-select v-model.trim="form.workStatus" placeholder="请选择在职状态" style="width:90%">
              <el-option
                v-for="item in userStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省市区">
            <el-select
              v-model.trim="provinceValue"
              @change="choseProvince"
              placeholder="省级地区"
              style="width:38%"
              clearable
            >
              <el-option
                v-for="item in provinceData"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-select
              v-model.trim="cityValue"
              @change="choseCity"
              placeholder="市级地区"
              style="width:30%"
              clearable
            >
              <el-option
                v-for="item in cityData"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-select
              v-model.trim="areaValue"
              @change="choseBlock"
              placeholder="区级地区"
              style="width:25%"
              clearable
            >
              <el-option
                v-for="item in areaData"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model.trim="form.address" placeholder="请输入详细地址" style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="直属部门" prop="parentName">
            <el-input
              v-model.trim="form.parentName"
              placeholder="请选择直属部门"
              v-on:click.native="openElTreeDialog"
              readonly
              style="width:90%"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm('form')">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')" :disabled="btnDisabled">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <OrganizationForUserDlg
      v-if="organizationDlgShow"
      @node-data="handleCallData"
      ref="organizationDlgRef"
    ></OrganizationForUserDlg>
  </div>
</template>
<script>
import DialogResize from "@/utils/DialogResize.js";
import OrganizationForUserDlg from "../organizationManage/OrganizationForUserDlg.vue";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [DialogResize],
  components: {
    OrganizationForUserDlg
  },
  computed: {},
  data() {
    return {
      sexType: [
        {
          value: "0",
          label: "男"
        },
        {
          value: "1",
          label: "女"
        },
        {
          value: "2",
          label: "未知"
        }
      ],
      btnDisabled: false,
      percent: 0,
      showPlus: true,
      imgFlag: false,
      loading: false,
      userStatus: [],
      doUpload: this.$constant.API_NSC + "file/upload/single",
      dialogImageUrl: "",
      dialogVisible: false,
      imageUrl: "",
      provinceValue: "",
      cityValue: "",
      areaValue: "",
      provinceData: [],
      cityData: [],
      areaData: [],
      province: "",
      city: "",
      oldUserIcon: "",
      operateFlag: "",
      nowParentId: "",
      uploadFlag: false,
      isShowPwd: false,
      isDisabled: false,
      checkUserFlag: false,
      mainTitle: "",
      showParentId: "",
      parentId: "",
      parentName: "",
      imgUid: "",
      overAllRecordId: "",
      editVisible: false,
      organizationDlgShow: false,
      form: {
        parentName: "",
        parentId: "",
        userName: "",
        password: "",
        sex: "",
        email: "",
        userIcon: "",
        idCard: "",
        age: "",
        entryAt: "",
        workStatus: "",
        areaCode: "",
        address: "",
        realName: "",
        nickName: "",
        mobile: "",
        role: ""
      },
      rules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          {
            validator: function(rule, value, callback) {
              if (value != null && value != "") {
                if (/^[A-Za-z0-9-]{4,40}$/.test(value) == false) {
                  callback(
                    new Error("用户名输入4-40位字符且不能输入特殊符号")
                  );
                } else {
                  callback();
                }
              } else {
                return callback();
              }
            }
          }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "密码输入不能超过200个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: "不可输入中文"
          }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "邮箱输入不能超过100个字符，请重新输入",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (value != null && value != "") {
                if (
                  /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("请输入有效的邮箱"));
                } else {
                  callback();
                }
              } else {
                return callback();
              }
            }
          }
        ],
        realName: [
          { required: true, message: "用户姓名不能为空", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "用户姓名输入至少2个字符且不能超过20个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            message: "不允许输入空格等特殊符号"
          }
        ],
        sex: [{ required: true, message: "性别不能为空", trigger: "blur" }],
        idCard: [
          { required: false, message: "身份证不能为空", trigger: "blur" },
          {
            min: 1,
            max: 18,
            message: "身份证输入不能超过18个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证输入不合法"
          }
        ],
        age: [
          { required: false, message: "年龄不能为空", trigger: "blur" },
          {
            validator: function(rule, value, callback) {
              let reg = /^(?:[1-9][0-9]?|1[01][0-9]|120)$/; //年龄是1-120之间有效
              if (value == undefined) {
                callback([new Error("帐号输入不合法")]);
              } else {
                if (value && value.length > 0) {
                  if (!reg.test(value)) {
                    callback([new Error("年龄输入不合法")]);
                  } else {
                    callback();
                  }
                } else if (value.length == 0) {
                  callback();
                } else {
                  callback(new Error("年龄输入不合法"));
                }
              }
            }
          }
        ],
        mobile: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            validator: function(rule, value, callback) {
              if (value != null && value != "") {
                if (/^1[3456789]\d{9}$/.test(value) == false) {
                  callback(new Error("请输入正确的手机号"));
                } else {
                  callback();
                }
              } else {
                return callback();
              }
            }
          }
        ],
        entryAt: [
          { required: false, message: "入职时间不能为空", trigger: "change" }
        ],
        workStatus: [
          { required: true, message: "在职状态不能为空", trigger: "change" }
        ],
        address: [
          { required: false, message: "详细地址不能为空", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "详细地址输入不能超过100个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            message: "不允许输入空格等特殊符号"
          }
        ]
      }
    };
  },
  methods: {
    init(param, row, operateFlag) {
      this.loading = false;
      this.btnDisabled = false;
      this.initProvinceData();
      this.initUserStatus();
      this.uploadFlag = false;
      this.checkUserFlag = false;
      this.nowParentId = param.parentId;
      this.provinceValue = "";
      this.cityData = [];
      this.cityValue = "";
      this.areaData = [];
      this.areaValue = "";
      if (operateFlag == "add") {
        this.showParentId = param.parentId;
        this.parentId = param.parentId;
        this.parentName = param.parentName;
        this.mainTitle = "新增人员";
        this.operateFlag = "add";
        this.isDisabled = false;
        this.isShowPwd = true;
        this.imgUid = "";
        this.imageUrl = "";
        this.form = {
          id: "",
          parentId: param.parentId,
          parentName: param.parentName,
          userIcon: "",
          userName: "",
          password: "",
          email: "",
          realName: "",
          sex: "",
          idCard: "",
          age: "",
          mobile: "",
          entryAt: "",
          address: "",
          workStatus: "100101"
        };
      }
      if (operateFlag == "update") {
        this.mainTitle = "编辑";
        this.operateFlag = "update";
        this.isDisabled = true;
        this.isShowPwd = false;
        if (row.userIcon && row.userIcon != "") {
          this.downloadImage(row.userIcon);
          this.oldUserIcon = row.userIcon;
        }
        this.getStaffById(row.id);
      }
      this.editVisible = true;
    },
    customUpload(file) {
      this.imgFlag = true;
      this.showPlus = false;
      let param = {
        file: file.file,
        recordId: this.overAllRecordId,
        typeId: "1"
      };
      this.$mhttp
        .httpFilePost(
          this.$constant.API_NSC + "file/upload/single",
          param,
          null,
          progress => {
            let loaded = progress.loaded,
              total = progress.total;
            this.$nextTick(() => {
              this.percent =
                Math.floor((loaded / total) * 100) > 1
                  ? Math.floor((loaded / total) * 100)
                  : 1;
            });
          }
        )
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.imageUrl = URL.createObjectURL(file.file);
            this.imgUid = res2.data.data.id;
            this.uploadFlag = true;
            this.imgFlag = false;
            this.$message.success("上传成功！");
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/JPEG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    onSubmit(formName) {
      // this.checkUserName(v.userName);
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.btnDisabled = true;
          let v = this.form;
          //判断省市区选择了哪一个
          let areaParam = "";
          if (
            this.provinceData.length != 0 &&
            this.provinceValue &&
            this.provinceValue != ""
          ) {
            if (
              this.cityData.length != 0 &&
              this.cityValue &&
              this.cityValue != ""
            ) {
              if (
                this.areaData.length != 0 &&
                this.areaValue &&
                this.areaValue != ""
              ) {
                areaParam = this.areaValue;
              } else {
                areaParam = this.cityValue;
              }
            } else {
              areaParam = this.provinceValue;
            }
          } else {
            areaParam = "";
          }
          let param = {
            id: v.id,
            deptId: v.parentId,
            userIcon: this.imgUid,
            userName: v.userName,
            password: v.password,
            email: v.email,
            realName: v.realName,
            sex: v.sex,
            idCard: v.idCard,
            age: v.age,
            mobile: v.mobile,
            entryAt: v.entryAt,
            workStatus: v.workStatus,
            address: v.address,
            areaCode: areaParam
          };

          this.saveAndUpdate(param);
        } else {
          console.log("error submit!!");
          this.loading = false;
          return false;
        }
      });
    },
    saveAndUpdate(param) {
      SettingApi.getClass()
        .saveStaff(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.$message.success("保存成功！");
            this.loading = false;
            this.btnDisabled = false;
            this.overAllRecordId = res2.data.data.id;
            //如果是新增 不保存
            if (this.uploadFlag == true) {
              //如果新的imgUid跟旧的不一样
              // if (this.imgUid != this.oldUserIcon) {
              this.updateFileFlag(this.overAllRecordId, this.imgUid);
              // }
            }
            //关闭弹窗
            this.editVisible = false;
            //刷新右边列表数据
            this.$parent.getListData(this.nowParentId);
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    },
    checkUserName(userName) {
      if (userName != undefined && userName != null && userName != "") {
        SettingApi.getClass()
          .checkUserName(userName)
          .then(res2 => {
            if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
              this.$message.success("该帐号可以使用！");
              this.checkUserFlag = true;
            } else {
              // this.rules.userName[0].required = true;
              // this.rules.userName[0].message = res2.data.msg;
              this.loading = false;
              this.$message.error(res2.data.msg);
              return false;
            }
          })
          .catch(err => {
            this.loading = false;
            this.$message.error(err);
            return false;
          });
      }
    },
    updateFileFlag(recordId, imgUid) {
      let ids = [];
      ids.push(imgUid);
      let param = {
        ids: ids
      };
      // this.$mhttp
      //   .httpPost(
      //     this.$constant.API_NSC + "file/" + recordId + "/updateFlag",
      //     param,
      //     "application/json"
      //   )
      SettingApi.getClass()
        .updateFileFlag(recordId, param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            // this.$message.success("111");
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    downloadImage(imgUid) {
      SettingApi.getClass()
        .downloadFile(imgUid)
        .then(res2 => {
          this.imageUrl = URL.createObjectURL(res2.data);
          this.showPlus = false;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    }, //清空表单验证
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.parentName = "";
      this.form.parentId = "";
      this.editVisible = false;
    },
    openElTreeDialog() {
      this.organizationDlgShow = true;
      this.$nextTick(() => {
        // type 必传 0表示全部的组织架构 每个都可以选 1 表示分部  2部门
        // id  可选  传入id可以默认选中当前传入的id节点 如果不需要默认选中 就传null
        this.$refs.organizationDlgRef.init(0, this.showParentId, null);
      });
    },
    handleCallData(nodeData) {
      if (nodeData.length == 1) {
        this.form.parentName = nodeData[0].name;
        this.form.parentId = nodeData[0].id;
      } else {
        this.form.parentName = "";
        this.form.parentId = "";
        for (let i = 0; i < nodeData.length; i++) {
          if (i == nodeData.length - 1) {
            this.form.parentName += nodeData[i].name;
            this.form.parentId += nodeData[i].id;
          } else {
            this.form.parentName += nodeData[i].name + ",";
            this.form.parentId += nodeData[i].id + ",";
          }
        }
      }
      if (this.form.parentId && this.form.parentId != "") {
        this.showParentId = this.form.parentId;
      }
    },
    closeEdit() {
      this.$refs["form"].resetFields();
      this.form.parentName = "";
      this.form.parentId = "";
    },
    getStaffById(id) {
      this.loading = true;
      this.btnDisabled = true;
      SettingApi.getClass()
        .getStaffById(id)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.loading = false;
            this.btnDisabled = false;
            let data = res2.data.data;
            this.showParentId = data.deptId;
            this.parentId = data.deptId;
            this.parentName = data.deptName;
            this.form = {
              id: data.id,
              parentId: data.deptId,
              parentName: data.deptName,
              userName: data.userName,
              // password: data.password,
              email: data.email,
              realName: data.realName,
              sex: data.sex,
              idCard: data.idCard,
              //数据库中返回的是int 前端这边定义的为"""
              age: data.age != null && data.age != "" ? data.age + "" : "",
              mobile: data.mobile,
              entryAt: data.entryAt,
              address: data.address,
              workStatus: data.workStatus
            };
            if (data.areaKeys && data.areaKeys != "") {
              let areaKeys = data.areaKeys;
              let areaArr = areaKeys.split(",");
              for (let i = 0; i < areaArr.length; i++) {
                this.provinceValue = areaArr[0];
                this.cityValue = areaArr[1];
                this.areaValue = areaArr[2];
              }
              //如果省市区其中有值
              if (this.provinceValue && this.provinceValue != "") {
                this.initCityData(areaArr[0], false);
              }
              if (this.cityValue && this.cityValue != "") {
                this.initAreaData(areaArr[1], false);
              }
            }
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    },
    choseProvince: function(e) {
      this.provinceValue = e;
      if (e && e != "") {
        this.initCityData(e, true);
      } else {
        this.cityData = [];
        this.cityValue = "";
        this.areaData = [];
        this.areaValue = "";
      }
    },
    // 选市
    choseCity: function(e) {
      this.cityValue = e;
      if (e && e != "") {
        this.initAreaData(e, true);
      } else {
        this.areaData = [];
        this.areaValue = "";
      }
    },
    // 选区
    choseBlock: function(e) {
      this.areaValue = e;
    },
    // 初始化省级数据
    initProvinceData() {
      SettingApi.getClass()
        .initProvinceData()
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.provinceData = res2.data.data.provinces;
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    // 初始化市级数据
    initCityData(parentKey, flag) {
      let param = {
        parentKey: parentKey
      };
      SettingApi.getClass()
        .initCityData(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.cityData = [];
            if (data != null && data.length != 0) {
              for (let i = 0; i < data.length; i++) {
                obj = {
                  value: data[i].value,
                  key: data[i].key
                };
                this.cityData.push(obj);
              }
              if (flag == true) {
                this.cityValue = this.cityData[0].key;
                this.initAreaData(data[0].key, flag);
              }
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    // 初始化区级数据
    initAreaData(parentKey, flag) {
      let param = {
        parentKey: parentKey
      };
      SettingApi.getClass()
        .initAreaData(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.areaData = [];
            for (let i = 0; i < data.length; i++) {
              obj = {
                value: data[i].value,
                key: data[i].key
              };
              this.areaData.push(obj);
              if (flag == true) {
                this.areaValue = this.areaData[0].key;
              }
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    initUserStatus() {
      let param = {
        parentCode: this.$constant.DICT_USER_STATUS
      };
      SettingApi.getClass()
        .initUserStatus(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.userStatus = [];
            if (data != null && data.length != 0) {
              for (let i = 0; i < data.length; i++) {
                obj = {
                  value: data[i].code,
                  label: data[i].name
                };
                this.userStatus.push(obj);
              }
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    }
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px !important;
  height: 150px !important;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid aliceblue;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
